import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ClientCommands, ClientCommandsService } from '@services/ClientCommands.service';
import { Subject, first, take, takeUntil } from 'rxjs';
import { ContextService } from '../../../@core/services/Context.service';
import { PubSubService } from '../../../@core/services/PubSub.service';
import { Joove } from '../../core/Joove';
import { ZAppDevModalComponent } from '../Modal/modal.component';
import { ZAppDevSidebarComponent } from '../Sidebar/sidebar.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'zapp-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.less']
})
export class zAppDevFormModalComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected pubSubService: PubSubService,
    protected clientCommander: ClientCommandsService,
    protected contextService: ContextService,
    protected readonly titleService: Title,
    protected translsateService: TranslateService,
  ) {

    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation?.extras?.state != null) {
      this.style = currentNavigation.extras.state.style ?? this.style;
      this.data = currentNavigation.extras.state.data;
    }

    this.contextService.context$.pipe(takeUntil(this.destroy$)).subscribe((context: Joove.IContext) => {
      this.updateTitle();
    });

  }

  protected destroy$: Subject<void> = new Subject<void>();

  @ViewChild('FormModal')
  formModal: ZAppDevModalComponent;

  @ViewChild('FormSidebar')
  formSidebar: ZAppDevSidebarComponent;

  style = 'width: 100vw';
  data: any = {};

  protected title: string = '';

  async ngOnInit(): Promise<void> {

    const modalRouteIndex = this.router.url.indexOf('(modal:');
    if (modalRouteIndex >= 0) {
      const controllerAndActionStr = this.router.url.substring(modalRouteIndex).replace('(modal:', '').replace(')', '');
      const arr = controllerAndActionStr.split('/');
      const controller = arr[0];
      const action = arr[1];
      this.title = this.translsateService.instant(`${controller}_RES_PAGETITLE_${action}`);
    }
  }

  ngAfterViewInit(): void {
    if (this.data?.isSlide) {
      this.formSidebar.showDialog();
    } else {
      this.formModal.showDialog();
    }
  }

  closeModal() {

    if (this.data?.executeOnClose != null) {
      this.pubSubService.publish('form-modal-close', 'CLOSE_FORM', { data: this.data });
    }

    this.clientCommander.executeCommand(ClientCommands.CLOSE_FORM);
  }

  updateTitle() {
    
    if (this.title != null && this.title.trim().length > 0) {
      return;
    }

    const pageTitle = this.titleService.getTitle();
    this.title = pageTitle.substring(0, pageTitle.indexOf('|'));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

  }

}
